import React, {Component} from 'react';
import {List, Radio, InputItem, Toast, DatePicker, TextareaItem, Checkbox} from 'antd-mobile';
import {startCity, getBusEnd, charteredBusSubmit,getNearestOrder} from '../../../service/homeService';
import CityModal from "../../../components/CityModal";
import AgreementModal from "../../../components/AgreementModal";
import {connect} from "react-redux";
import './style.less';
import BMap from "BMap";
const CheckboxItem = Checkbox.CheckboxItem;
const now = new Date();
const baoche = require('../../../../src/common/image/baoche.png');

@connect(
    state => ({userInfo: state.userInfo})
)
export default class CharteredBus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cityModal:false,
            cityType:"charteredBus",
            modalType:"start",
            charteredType: [
                {value: 0, label: '单程'},
                {value: 1, label: '往返'},
                {value: 2, label: '按天'},
            ],
            charteredTypeVal:0,
            startCity:"请选择出发地",
            endCity:"请选择目的地",
            num:"",
            phone:"",
            date:"",
            description:"",
            cityData:{},
            startCityData:[],
            endCityData:[],
            nearestData:[],
            protocolVal:false,//同意协议
            agreementModal:false,
            province:this.props.province,
        };
    }


    componentDidMount() {
       this.getNearest()
        // let geolocation = new BMap.Geolocation();
        // const self = this;
        // geolocation.getCurrentPosition(function (r) {
        //     self.setState({province:r.address.province});
        // });
    }
    getNearest(){
        getNearestOrder({source:1, token:this.props.userInfo.token,}).then((res)=>{
            if(res.data.code == '0000'){
                this.setState({nearestData:res.data.data})
            }
        });
    }
    selCity(type){
        if(type == 'end' && this.state.startCity == "请选择出发地"){
            Toast.info('请先选择出发地');
        }else{
            if(type == 'start'){
                this.getStartCityList(this.state.province)
            }else if (type === 'end'){
                this.getEndCityList()
            }
            this.setState({cityModal: true, modalType: type,});
        }
    }
    //获取开始城市列表
    getStartCityList = (province,letter) => {
        this.setState({province: province});
        const params = {
            source:1,
            token:this.props.userInfo.token,
            data:{
                displayName:'',
                provinceName:province === "全部" ? "" : province,
                label:letter,
            },
        };
        startCity(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                this.setState({cityData: res.data.data});
            }else{
                Toast.info(res.data.msg,3)
            }
        })
    };
    getEndCityList = (letter) => {
        Toast.loading("");
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                displayName:this.state.startCity,
                label:letter,
            }
        };
        getBusEnd(params).then((res) => {
            if (res.data.code === '0000') {
                this.setState({cityData: res.data.data});
                Toast.hide();
            }else{
                Toast.info(res.data.msg,3)
            }
        })
    };
    onClose = () => {
        this.setState({cityModal: false,cityData:[],agreementModal:false});
    };
    changeCity(n){
        this.setState({cityModal: false,cityData:[]});
        if(this.state.modalType == 'start'){
            this.setState({startCity: n.name,});
        }else{
            this.setState({endCity: n.name,endCityData:n});
        }

    }
    changeTime = (value, key) => {
        this.setState({[key]: value,});
    };
    inputChange = key =>(e) =>{
        this.setState({ [key]: e })
    };
    submit(){
        const {charteredTypeVal,startCity,endCity,date,num,phone,description,endCityData}=this.state;
        if(startCity === "请选择出发地"){
            Toast.info("请选择出发地");
            return
        }
        if(endCity === "请选择目的地"){
            Toast.info("请选择目的地");
            return
        }
        if(date === ""){
            Toast.info("请选择用车时间");
            return
        }
        if(num === ""){
            Toast.info("请输入出行人数");
            return
        }
        if(phone === ""){
            Toast.info("请输入手机号");
            return
        }
        if(this.state.protocolVal === false){
            Toast.info("请同意用户协议后购票");
            return
        }
        let params={
            source:1,
            token:this.props.userInfo.token,
            data:{
                orderSource:1,
                orderType:charteredTypeVal,
                startAddress:startCity,
                endAddress:endCity,
                endStationId:endCityData.stattionId,
                endStationLocation:endCityData.lat+"_"+endCityData.lng,
                estimatedTimeOfDeparture:date,
                passagerNum:num,
                phone:phone,
                description:description,
            },
        };
        Toast.loading("");
        charteredBusSubmit(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.success('提交成功',3,()=>this.clearText());

            }else{
                Toast.info(res.data.msg,3)
            }
        })
    }

    clearText(){
        this.setState({
            modalType:"start",
            charteredTypeVal:0,
            startCity:"请选择出发地",
            endCity:"请选择目的地",
            num:"",
            phone:"",
            date:"",
            description:"",
            endCityData:[],
            cityData:[],
        });
        this.getNearest()
    }
    getTitle(data){
        if(data.orderGenre == 0){
            return "单程包车"
        }
        if(data.orderGenre == 1){
            return "往返包车"
        }
        if(data.orderGenre == 2){
            return "按天包车"
        }
    }
    //订单状态
    showType(type){
        switch(type){
            case 0 :
                return  <span style={{color:"#25C39E"}}>待审核</span>;
            case 1 :
                return  <span style={{color:"#FF0000"}}>待付款</span>;
            case 2 :
                return  <span style={{color:"#F79E24"}}>待出行</span>;
            case 3 :
                return  <span style={{color:"#22BE28"}}>行程中</span>;
            case 4 :
                return  <span style={{color:"#616372"}}>已完成</span>;
            case 99 :
                return  <span style={{color:"#D9D9DE"}}>已取消</span>;
        }
    }
    protocolChange =(e)=>{
        this.setState({protocolVal:e.target.checked});
    };
    render() {
        return (
            <div className="chartered">
                <div className="top">
                    <div className="list">
                        定制类型
                        {this.state.charteredType.map((res, i) => (
                            <Radio className="my-radio" key={i} checked={this.state.charteredTypeVal === res.value}
                                   onChange={() => this.setState({charteredTypeVal: res.value})}>
                                {res.label}
                            </Radio>
                        ))}
                    </div>
                    <List.Item arrow="horizontal" extra={this.state.startCity} className="start" onClick={() => this.selCity('start')}>出发地</List.Item>
                    <List.Item arrow="horizontal" extra={this.state.endCity} className="start" onClick={() => this.selCity('end')}>目的地</List.Item>
                    <DatePicker
                        title="选择日期"
                        // minDate={new Date(+now + 7200000)}
                        minDate={new Date(now)}
                        cols={4}
                        mode="datetime"
                        value={this.state.date}
                        onChange={date => this.setState({ date })}
                        onOk={(v) =>this.changeTime(v, 'date')}
                    >
                        <List.Item arrow="horizontal" className="start" >用车时间</List.Item>
                    </DatePicker>

                    <div className="list">
                        <InputItem
                            type="number"
                            maxLength={1}
                            className="inp"
                            placeholder="请输入出行人数"
                            value={this.state.num}
                            onChange={this.inputChange("num")}
                            onBlur={v => window.scroll(0,0)}
                        >出行人数</InputItem>
                        <span>(6人以内)</span>
                    </div>

                    <div className="list" style={{borderBottom:'none'}}>
                        <InputItem
                            maxLength={11}
                            type="number"
                            className="inp"
                            placeholder="请输入联系电话"
                            value={this.state.phone}
                            onChange={this.inputChange("phone")}
                            onBlur={v => window.scroll(0,0)}
                        >联系电话</InputItem>
                    </div>

                    <div className="list" style={{borderBottom:'none'}}>
                        <TextareaItem
                            title="订单备注"
                            placeholder="请填写备注"
                            ref={el => this.autoFocusInst = el}
                            autoHeight
                            value={this.state.description}
                            onChange={this.inputChange("description")}
                            onBlur={v => window.scroll(0,0)}
                        />
                    </div>
                </div>
                <div className="protocol">
                    <CheckboxItem  onChange={(e) => this.protocolChange(e)} checked={this.state.protocolVal}>
                        <div onClick={() => this.setState({agreementModal:true})}>《民途出行用户协议》</div>
                    </CheckboxItem>
                </div>
                <button onClick={()=>this.submit()}>申请定制</button>

                {
                    this.state.nearestData.length > 0 ? (
                        <div className="bottoms">
                            <div className="tit">最近订单</div>
                            {
                                this.state.nearestData.map((res,i)=>(
                                    <div className="orderListItem" key={i} >
                                        <div className="header">
                                            <div><img src={baoche}/></div>
                                            <div className="orderNumber">{this.getTitle(res)}</div>
                                            <div className="orderType">{this.showType(res.status)}</div>
                                        </div>
                                        <div className="info">
                                            <div className="box">
                                                <div className="endBox"><i className="icon iconfont iconshijian" /><span>{res.startDate} {res.startTime}  {res.passengerNum+'人'}</span></div>
                                                <div className="endBox">
                                                    <i className="icon iconfont iconchufadi" />
                                                    <span className="address">{res.startCity }</span>
                                                </div>

                                                <div className="endBox">
                                                    <i className="icon iconfont iconmudedi" />
                                                    <span className="address">{res.endCity }</span>
                                                </div>
                                            </div>
                                            <div className="goRefund" onClick={()=>this.props.history.push(`/orderDetail/${res.id}`, {orderType: res.orderType})}>查看</div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    ):null
                }


                <AgreementModal
                    modal={this.state.agreementModal}
                    onClose={this.onClose.bind(this)}
                />
                <CityModal
                    modal={this.state.cityModal}
                    modalType={this.state.modalType}//出发还是到达的modal
                    onClose={this.onClose.bind(this)}
                    data={this.state.cityData}//城市列表数据
                    changeCity={this.changeCity.bind(this)}//切换城市事件
                    cityType = {this.state.cityType}
                    hotData=""
                    nearbySite=""
                    province={this.state.province}
                    getStartCityList={this.getStartCityList.bind(this)}
                    getEndCityList={this.getEndCityList.bind(this)}
                    {...this.props}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/CharteredBus/index.js